import React,  { useEffect, useState } from 'react';
import firebase from 'firebase/app'
import NavBar from '../NavBar/NavBar'

function Account () {
    const [state, setState] = useState({
        name: '',
        location: '',
        bio: '',
        link1: '',
        link2: '',
        link3: '',
        forHire: false,
    })
const [is_saving, setSaving] = useState(false)
    const handleUpdate = (e, prop) => {
        setState({
            ...state,
            [prop]: e.target.value
        })
    }

    useEffect(() => {
        const user = firebase.auth().currentUser
        if(!user)
        {
            window.location.hash = "#/"
            return
        }
        loadData(user.uid)
    },[])

    const loadData = (uid) => {
        firebase.firestore().collection("users").doc(uid)
        .get().then(snap => {
            if(snap.exists) {
                setState({
                    ...state,
                    ...snap.data()
                })
            }
        })
    }
    const saveInfo = () => {
        setSaving(true)
        const user = firebase.auth().currentUser
        firebase.firestore().collection("users").doc(user.uid)
        .set(state, { merge : true})
        .then(_ => {
            setSaving(false)
            window.location.hash = "#/profile"
        })
        .catch(e => {
            setSaving(false)
            alert(e)
        })
    }
        return (
            <div>
                <NavBar />
                <div className="component-account">
                    <div className="account-container">
                        <div className="account-header">
                            <div className="account-save">
                                <button onClick={() => saveInfo()}>{is_saving ? 'Saving' : 'Save All Settings'}</button>
                            </div>
                            <div className="account-links">
                                <p>Edit Profile</p>
                            </div>
                        </div>
                            <div className="account-grid"> 
                                <div className="account-information">
                                    <div className="information-box">
                                        <div className="box-header">
                                            <h3>Name and Location</h3>
                                        </div>
                                        <div className="input-container">
                                            <div className="input-group">
                                                <h5>Profile Name</h5>
                                                <input type="text" value={state.name} onChange={(e) => handleUpdate(e, "name")} />
                                            </div>
                                            <div className="input-group">
                                                <h5>Location</h5>
                                                <input type="text" onChange={(e) => handleUpdate(e, "location")} value={state.location} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="information-box bio py-5">
                                        <div className="box-header">
                                            <h3>Bio</h3>
                                        </div>
                                        <div className="textarea-group mb-5">
                                            <div className="title">
                                                <h5>About You</h5>
                                            </div>
                                            <div className="textarea">
                                                <textarea className="p-2" onChange={(e) => handleUpdate(e, "bio")} value={state.bio}></textarea>
                                                <p className="mb-3">{state.bio ? state.bio.length : 0}/100 <span className="small">characters used.</span></p>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="information-box">
                                        <div className="box-header">
                                            <h3>Links</h3>
                                        </div>
                                        <div className="input-container">
                                            <div className="input-group">
                                                <h5>Profile Link #1</h5>
                                                <input type="text" onChange={(e) => handleUpdate(e, "link1")} value={state.link1} />
                                            </div>
                                            <div className="input-group">
                                                <h5>Profile Link #2</h5>
                                                <input type="text" onChange={(e) => handleUpdate(e, "link2")} value={state.link2} />
                                            </div>
                                            <div className="input-group">
                                                <h5>Profile Link #3</h5>
                                                <input type="text" onChange={(e) => handleUpdate(e, "link3")} value={state.link3} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="information-box">
                                        <div className="box-header">
                                            <h3>Are you for hire?</h3>
                                        </div>
                                        <div className="slider-container">
                                            <p>Yes</p>
                                            <label className="switch">
                                                <input type="checkbox" checked={state.forHire} onChange={e => setState({
                                                    ...state,
                                                    forHire : !state.forHire
                                                })} />
                                                Yes  <span className="slider round"></span> No
                                            </label>
                                            <p>No</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        )
    }


export default Account;


// WEBPACK FOOTER //
// ./src/components/Account/account.js